<template>
  <div>
    <BlFlexContainerMv direction="row" align-items="center" padding="18px">
      <BlFlexItemAv margin="0 14px 0 0">
        <BlProductImageAv
          is-lazy-load
          :image-url="merchantDetail.logo_url"
          :image-alt="merchantDetail.name"
          size="extra-small"
          class="qa-merchant-logo"
        />
      </BlFlexItemAv>
      <BlFlexItemAv shrink="1">
        <BlTextAv tag="h2" variation="body-14" weight="bold" class="qa-merchant-name">{{ merchantDetail.name }}</BlTextAv>
        <BlTextAv v-if="false" variation="caption-12" class="flex items-center mt-4">
          <IcoGroup color="#B6B6B6" width="24" height="24" style="width: 20px; height: 20px" />100rb orang telah mengikuti kelas disini
        </BlTextAv>
      </BlFlexItemAv>
    </BlFlexContainerMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlProductImageAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoGroup} from '@bukalapak/bazaar-visual-next';

export default {
  name: 'PrakerjaMerchantHeader',
  components: {
    BlProductImageAv,
    IcoGroup,
  },
  computed: {
    ...mapGetters({
      merchantDetail: 'merchants/getMerchantDetail',
    }),
  },
};
</script>
